/**
 * An action under way (ADR-0108): what `/api/chat` says in `action`, checked
 * before the panel draws anything from it. Anything malformed is dropped —
 * the reply text still says what the assistant needs.
 */
const STATES = new Set(['asking', 'confirming', 'done', 'cancelled', 'failed']);
export const COMMANDS = new Set(['confirm', 'change', 'cancel']);
const MAX_ITEMS = 12;

const short = (value, max) => (typeof value === 'string' && value.trim() !== '' ? value.slice(0, max) : null);

export function normalizeAction(raw) {
  if (!raw || typeof raw !== 'object' || !STATES.has(raw.state)) return null;
  const options = Array.isArray(raw.options) ? raw.options.map((option) => short(option, 60)).filter(Boolean).slice(0, MAX_ITEMS) : [];
  const summary = Array.isArray(raw.summary)
    ? raw.summary
      .map((row) => (row && typeof row === 'object' ? { label: short(row.label, 60), value: short(row.value, 500) } : null))
      .filter((row) => row && row.label && row.value)
      .slice(0, MAX_ITEMS)
    : [];
  // The card's own words in the conversation's language (ADR-0108); the
  // widget's when any is missing.
  const labels = raw.labels && typeof raw.labels === 'object' ? raw.labels : {};
  const words = Object.fromEntries(['review', 'confirm', 'change', 'cancel'].map((key) => [key, short(labels[key], 60)]));
  return {
    name: short(raw.name, 120) || '',
    state: raw.state,
    options: raw.state === 'asking' ? options : [],
    summary: raw.state === 'confirming' ? summary : [],
    labels: Object.values(words).every(Boolean) ? words : null,
  };
}
